import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { TextInputField, SelectField, DEFAULT_REQUIRED_MESSAGE
  } from 'common/components/form_fields';

const BillingForm = ({error, handleSubmit, submitting, submitFailed, countries}) => (

  <form onSubmit={handleSubmit}>
    <div className="row">
      <div className="columns medium-8 small-16">
        <Field name="billing_name" component={TextInputField} label="Name"/>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-8 small-16">
        <Field name="billing_address_line_1" component={TextInputField} label="Address 1" />
      </div>
      <div className="columns medium-8 small-16">
        <Field name="billing_address_line_2" component={TextInputField} label="Address 2"/>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-8 small-16">
        <Field name="billing_city" component={TextInputField} label="City"/>
      </div>
      <div className="columns medium-8 small-16">
        <Field name="billing_state" component={TextInputField} label="State"/>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-8 small-16">
        <Field name="billing_postal_code" component={TextInputField} label="ZIP / Postal Code"/>
      </div>
      <div className="columns medium-8 small-16">
        <Field name="billing_country" component={SelectField} allowEmpty={true}
          label="Country" options={countries}/>
      </div>
    </div>

    <AnimatedButton processing={submitting} type="submit" label="Save Changes"
      processingLabel="Saving..." errorMsg={error || submitFailed} successMsg="Saved!"/>
  </form>
)

const validate = values => {
  const errors = {}
  const requiredFields = [
    'billing_name', 'billing_address_line_1', 'billing_city', 'billing_state',
    'billing_country', 'billing_postal_code'
  ]
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE
  }
  return errors
}

export default reduxForm({
  form: "BillingForm",
  validate,
})(BillingForm);



// WEBPACK FOOTER //
// ./account/components/billing_form.jsx